var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CContainer',{staticClass:"approve-request-container"},[_c('LoginFormComponent',{attrs:{"formType":_vm.isExpired==true? 'EXPIRED_APPROVE_REQUEST_LINK' : 'APPROVE_REQUEST',"formTitle":_vm.isExpired==true ? 'Link expired' : ''}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }